import React from 'react'
import { VideoInsert as VideoInsertType } from '../../types/video'
import VideoPlayer from '../Video/Player'

interface Props {
  insert: VideoInsertType
}

const VideoInsert: React.FC<Props> = ({ insert }) => {
  return (
    <VideoPlayer
      video={{
        autoPlay: insert.autoPlay,
        loop: insert.loop,
        videoSources: insert.videoSources,
      }}
    />
  )
}

export default VideoInsert
